import { render, staticRenderFns } from "./line-echarts.vue?vue&type=template&id=52645861&scoped=true"
import script from "./line-echarts.vue?vue&type=script&lang=js"
export * from "./line-echarts.vue?vue&type=script&lang=js"
import style0 from "./line-echarts.vue?vue&type=style&index=0&id=52645861&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52645861",
  null
  
)

export default component.exports